import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ServiceCard from '../ui/ServiceCard';
import { PORTFOLIO_DATA } from '../../utils/constants';
import { Code, Sparkles, ArrowRight } from 'lucide-react';
import './Services.css';

const Services = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.6, -0.05, 0.01, 0.99]
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: [0.6, -0.05, 0.01, 0.99]
      }
    }
  };

  return (
    <section id="services" className="services section" ref={ref}>
      <div className="services-background">
        <div className="services-mesh">
          <div className="mesh-gradient mesh-1"></div>
          <div className="mesh-gradient mesh-2"></div>
        </div>
      </div>

      <div className="container">
        <motion.div
          className="section-header"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.div variants={itemVariants} className="section-badge">
            <Sparkles size={16} />
            <span>What I Do</span>
          </motion.div>
          
          <motion.h2 variants={itemVariants} className="section-title">
            Services & Solutions
          </motion.h2>
          
          <motion.p variants={itemVariants} className="section-subtitle">
            Transforming ideas into digital reality with cutting-edge technologies and creative solutions
          </motion.p>
        </motion.div>
        
        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {PORTFOLIO_DATA.services.map((service, index) => (
            <motion.div
              key={service.id}
              variants={cardVariants}
              transition={{ delay: index * 0.1 }}
            >
              <ServiceCard {...service} />
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="services-cta"
          variants={itemVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <div className="cta-content">
            <Code size={32} className="cta-icon" />
            <h3>Ready to start your project?</h3>
            <p>Let's discuss your ideas and turn them into amazing digital experiences</p>
            <a href="#contact" className="btn btn-primary">
              Start a Project
              <ArrowRight size={20} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;